module.exports = __webpack_public_path__ + "img/icon_jcguize.aa9d10af.svg";